import React, { useContext } from "react";
import { createPortal } from "react-dom";
import { ToastContext } from "../contexts/ToastContext";
import { Toast } from "./Toast";

export const ToastContainer: React.FC = () => {
  const context = useContext(ToastContext);

  if (!context) {
    return null;
  }

  const { toasts, removeToast } = context;

  if (toasts.length === 0) {
    return null;
  }

  return createPortal(
    <div
      className="toast-container"
      style={{
        position: "fixed",
        bottom: "24px",
        right: "24px",
        zIndex: 100000,
        display: "flex",
        flexDirection: "column-reverse",
        pointerEvents: "none",
      }}
    >
      {toasts.map((toast) => (
        <div key={toast.id} style={{ pointerEvents: "auto" }}>
          <Toast toast={toast} onClose={() => removeToast(toast.id)} />
        </div>
      ))}
    </div>,
    document.body
  );
};
